<div class="clients-publish-selector" [ngClass]="{ focus: focus }">
  <div class="itineraries-form__title margin-top__form margin-bottom">
    <span>{{ title | translate }}</span>
    <button
      *ngIf="!hideButtons"
      type="button"
      lmsTooltip
      [tooltipConfig]="{ positionV: 'top', positionH: 'center', text: ['itineraries.course.select' | translate] }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
  <gl-button
    *ngIf="!hideButtons"
    color-secondary
    [text]="'actions.selectCourse' | translate"
    class="itineraries-form__button"
    (onClick)="openCoursesSelector()"
  ></gl-button>
  <div class="itineraries-form__cards">
    <div cdkDropList (cdkDropListDropped)="changeCourseOrder($event)">
      <div
        class="itineraries-form__cards--item"
        *ngFor="let course of itineraryCourses; let x = index"
        cdkDrag
        [cdkDragDisabled]="hideButtons"
      >
        <div class="custom-placeholder" *cdkDragPlaceholder></div>
        <lms-course-item
          (deleteCourse)="deleteCourse(course)"
          [course]="course"
          [hideButtons]="hideButtons"
          [unavailableCourse]="unavailableCourses?.includes(course.id)"
        ></lms-course-item>
      </div>
    </div>
  </div>
</div>

<!-- Change selected courses modal -->
<lms-modal #modalCoursesSelector centered="true" size="x-large" class="padding-none">
  <div class="gl-popup__header">
    <span class="title">{{ 'courses.selectCourseTitle' | translate }}</span>
    <span class="subtitle"
      >({{ selectedCourses.length }}/{{ courses.length }} {{ 'courses.selectedCourses' | translate }})</span
    >
    <gl-search
      small
      [placeholder]="'actions.search' | translate"
      (onKeyup)="searchWords($event.detail.value)"
      (onClose)="searchWords('')"
    ></gl-search>
    <div class="gl-popup__close" (click)="modalCoursesSelector.close()">
      <span class="glicon-close"></span>
    </div>
  </div>
  <div class="gl-popup__body">
    <div *ngIf="!tempCourses.length" class="courses-body void">
      <span class="glicon-none-course"></span>
      <span class="courses-void__title">{{ 'courses.empty.searchTitle' | translate }}</span>
      <span class="courses-void__subtitle">{{ 'courses.empty.searchText' | translate }}.</span>
    </div>
    <div *ngIf="tempCourses.length" class="courses-cards modal-cards">
      <div
        *ngFor="let course of tempCourses"
        class="courses-cards__item selectorType"
        [ngClass]="{ selected: getChecked(course) }"
        (click)="selectCourse(course)"
      >
        <div class="courses-cards__check" [ngClass]="{ active: getChecked(course) }">
          <span class="glicon-check-circle"></span>
        </div>
        <div class="courses-cards__image">
          <img onError="this.style.display = 'none';" [src]="getImageUrl(course)" />
        </div>
        <div class="courses-cards__data">
          <div class="courses-cards__block">
            <span class="duration">
              {{ course.hours ? course.hours + 'h' : course.minutes ? '' : '0h' }}
              {{ course.minutes ? course.minutes + 'min' : '' }}
            </span>
          </div>
          <div class="courses-cards__title">
            {{ course.title }}
          </div>
          <div class="courses-cards__topic">
            {{ course.topic }}
          </div>
          <div class="courses-cards__originator">
            {{ course.clientName || course.creator }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gl-popup__footer">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalCoursesSelector.close()">
    </gl-button>
    <gl-button
      color-primary
      [text]="'actions.addCourses' | translate"
      class="margin-left"
      [disabled]="selectedCourses.length < 2"
      (onClick)="selectCourses()"
    >
    </gl-button>
  </div>
</lms-modal>

<!-- Delete selected course modal -->
<!-- <lms-modal #modalCoursesDelete size="small">
  <div class="gl-popup__title">{{ 'courses.deleteCourse' | translate }}</div>
  <div class="gl-popup__close" (click)="modalCoursesDelete.close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text">{{ 'courses.deleteCourseMessage' | translate }}</div>
  <div class="gl-popup__text">{{ 'courses.deleteCourseMessageInfo' | translate }}</div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalCoursesDelete.close()"></gl-button>
    <gl-button color-primary [text]="'actions.delete' | translate" (onClick)="confirmDelete()"></gl-button>
  </div>
</lms-modal> -->

<lms-modal #modalCoursesDelete size="small">
  <div class="gl-popup__close" (click)="modalCoursesDelete.close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__icon error centered">
    <span class="glicon-alert-thin"></span>
  </div>
  <div class="gl-popup__title centered">
    {{ 'courses.deleteCourse' | translate }}
  </div>
  <div class="gl-popup__text">
    {{ 'courses.deleteCourseInfo' | translate }}
  </div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalCoursesDelete.close()"></gl-button>
    <gl-button color-primary [text]="'actions.delete' | translate" (onClick)="confirmDelete()"></gl-button>
  </div>
</lms-modal>
